<template>
    <div class="TcAppointmentFormSuccess inline-block bg-white rounded-xl text-left overflow-hidden shadow-xl transform transition-all align-middle max-w-xl w-full px-9">
        <div class="py-10">
            <div class="flex flex-col items-center">
                <div class="mx-auto flex-shrink-0 flex items-center justify-center h-16 w-16 rounded-full bg-success text-white">
                    <svg class="h-10 w-10" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                    </svg>
                </div>
                <p class="mt-10 text-2xl text-center">Su inscrición<br>se ha realizado correctamente</p>
                <p class="mt-5 text-gray-500 text-center">Para realizar el pago acuda al <strong>Departamento de Administración</strong> y confirme la inscripción</p>
                <button @click="$parent.setPage($root.user ? 'events-my-calendar':'welcome')" class="w-full max-w-sm mt-10 btn-success">Continuar</button>
                <button @click="$root.logOut()" class="w-full max-w-sm mt-5 btn-secondary">Cerar sesión</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'TcInscriptionSuccess',
  data () {
    return {}
  }
}
</script>